export default {
    name: 'global',
    store() {
        return {
            isMobileMenuVisible: false,
            isMinicartVisible: false,
            openSearch: false,
            openFilters: false,
            // isPredictiveSearchVisible: false,
            isWindowScrolled: false,
            cart: null,
            cart_count: 0,
            body: "",
            scrollTopLock: 0,
            showPasswordReset: false,
            chosenCategoryFilter: [],
            chosenTypeFilter: [],

            init() {
                window.addEventListener('scroll', this.onWindowScrollHandler.bind(this))

                const cartOpen = new URLSearchParams(window.location.search).get('open');

                if (cartOpen == 'true') {
                    this.isMinicartVisible = true;
                }

                if (window.location.href.indexOf("#recover") != -1) {
                    this.showPasswordReset = true;
                }

                // Initialize chosenCategoryFilter from URL
                this.initCategoryFilterFromURL();

                this.initLiquidAJaxCart();

                this.body = document.querySelector("body");

                setTimeout(() => {
                    document.documentElement.style.setProperty("--announcement-bar-height", `${document.querySelector(".announcement-bar").getBoundingClientRect().height}px`);
                }, 100);
            },

            initTextOnMedia(resize = false) {
                let text = document.querySelector("[data-text]");
                let media = document.querySelector("[data-media]");

                if(resize) {
                    text.style.height = `auto`;
                    media.style.height = `auto`;
                }

                let textHeight = text.getBoundingClientRect().height;
                let mediaHeight = media.getBoundingClientRect().height;

                if(textHeight > mediaHeight) {
                    media.style.height = `${textHeight}px`;
                } else {
                    text.style.height = `${mediaHeight}px`;
                }

                window.addEventListener('resize', () => {
                    text.style.height = `auto`;
                    media.style.height = `auto`;
    
                    let textHeight = text.getBoundingClientRect().height;
                    let mediaHeight = media.getBoundingClientRect().height;
    
                    if(textHeight > mediaHeight) {
                        media.style.height = `${textHeight}px`;
                    } else {
                        text.style.height = `${mediaHeight}px`;
                    }
                });
            },

            setHeight(items) {
                // items.forEach((item) => {
                //     item.style.height = `100px`
                // });

                // setTimeout(() => {
                //     this.calcHeight(items);
                // }, 100);

                // setTimeout(() => {
                //     this.calcHeight(items);
                // }, 350);

                // window.addEventListener('resize', () => {
                //     this.calcHeight(items);
                // });
            },

            calcHeight(items) {
                let maxHeight = 0;
                items.forEach((item) => {
                    item.style.height = `auto`;
                    if(item.getBoundingClientRect().height > maxHeight) maxHeight = item.getBoundingClientRect().height;
                });
                items.forEach((item) => {
                    item.style.height = `${maxHeight}px`
                });
            },

            initCategoryFilterFromURL() {
                const urlParams = new URLSearchParams(window.location.search);
                const categoryParam = urlParams.get('category');
                
                if (categoryParam) {
                    // Support multiple categories separated by comma
                    this.chosenCategoryFilter = categoryParam.split(',').filter(cat => cat.trim() !== '');
                } else {
                    this.chosenCategoryFilter = [];
                }
            },

            updateCategoryFilterURL() {
                const url = new URL(window.location);
                
                if (this.chosenCategoryFilter.length > 0) {
                    url.searchParams.set('category', this.chosenCategoryFilter.join(','));
                } else {
                    url.searchParams.delete('category');
                }
                
                // Update URL without page reload
                window.history.replaceState({}, '', url);
            },

            toggleCategoryFilter(category) {
                const index = this.chosenCategoryFilter.indexOf(category);
                if (index === -1) {
                    this.chosenCategoryFilter.push(category);
                } else {
                    this.chosenCategoryFilter.splice(index, 1);
                }
                this.updateCategoryFilterURL();
            },

            clearCategoryFilter() {
                this.chosenCategoryFilter = [];
                this.updateCategoryFilterURL();
            },

            get bodyClasses() {
                let classes = []

                if (this.isMobileMenuVisible) {
                    classes.push('mobile-menu-visible')
                }
                if (this.isMinicartVisible) {
                    classes.push('cart-visible')
                }
                return classes || ''
            },

            openMobileMenu() {
                this.isMobileMenuVisible = true
                this.enableBodyScrollLock()
            },

            closeMobileMenu() {
                this.isMobileMenuVisible = false
                this.disableBodyScrollLock()
            },

            toggleMobileMenu() {
                this.isMobileMenuVisible = !this.isMobileMenuVisible

                if (this.isMobileMenuVisible) {
                    this.enableBodyScrollLock()
                } else {
                    this.disableBodyScrollLock()
                }
            },

            initLiquidAJaxCart() {
                document.addEventListener("liquid-ajax-cart:init", (event) => {
                    this.cart = window.liquidAjaxCart.cart;
                });

                document.addEventListener("liquid-ajax-cart:request-end", (event) => {
                    const { requestState, cart, previousCart, sections } = event.detail;

                    if (requestState.requestType === 'add') {
                        if (requestState.responseData?.ok) {
                            this.isMinicartVisible = true;
                            this.enableBodyScrollLock();
                        }
                    }
                    this.cart = cart
                    this.cart_count = this.cart.item_count
                });
            },

            onWindowScrollHandler() {
                const isScrolled = window.scrollY > 0

                this.isWindowScrolled = isScrolled
                document.body.classList[isScrolled ? 'add' : 'remove']('scrolled')
            },

            enableBodyScrollLock() {
                this.scrollTopLock =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.body.style.overflow = "hidden";
                this.body.style.position = "fixed";
                this.body.style.top = `-${this.scrollTopLock}px`;
                this.body.style.width = "100%";
            },

            disableBodyScrollLock() {
                this.body.style.removeProperty("overflow");
                this.body.style.removeProperty("position");
                this.body.style.removeProperty("top");
                this.body.style.removeProperty("width");
                window.scrollTo(0, this.scrollTopLock);
            },

            changeCart(id, qty = 1) {
                const body = {
                  id: id,
                  quantity: Number(qty)
                }
                
                const options = {
                  firstCallback: function(requestState) {
                    /**
                     * This callback function will be called first after the request is performed,
                     * thus none of request subscribers knows the result of the request,
                     * thus Cart state is not updated yet, sections are not updated yet,
                     * everything is not updated yet.
                     */
                  },
                  lastCallback: function(requestState) {
                    /**
                     * This callback-function will be called the latest
                     * among request subscribers,
                     * thus all the request subscribers are executed,
                     * thus Cart state is updated, sections are updated,
                     * everything is updated.
                     */
                  },
                  info: {
                    /**
                     * Any additional data you want to attach to the Request state object.
                     * Don't use the "initiator" and the "cancel" keys.
                     */
                    // myParameter: 'value'
                  },
                
                  // whether the request should go to the beginning of the queue rather than to the end
                  important: false
                }
                
                liquidAjaxCart.change(body, options);
            },

            addToCart(id, qty = 1) {
                const body = {
                  id: id,
                  quantity: Number(qty)
                }
                
                const options = {
                  firstCallback: function(requestState) {
                    /**
                     * This callback function will be called first after the request is performed,
                     * thus none of request subscribers knows the result of the request,
                     * thus Cart state is not updated yet, sections are not updated yet,
                     * everything is not updated yet.
                     */
                  },
                  lastCallback: function(requestState) {
                    /**
                     * This callback-function will be called the latest
                     * among request subscribers,
                     * thus all the request subscribers are executed,
                     * thus Cart state is updated, sections are updated,
                     * everything is updated.
                     */
                  },
                  info: {
                    /**
                     * Any additional data you want to attach to the Request state object.
                     * Don't use the "initiator" and the "cancel" keys.
                     */
                    // myParameter: 'value'
                  },
                
                  // whether the request should go to the beginning of the queue rather than to the end
                  important: false
                }
                
                liquidAjaxCart.add(body, options);
            }
        }
    }
}